import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyL, DisplayS } from '@sorare/core/src/atoms/typography';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LandingTitle } from 'components/landing/ui/LandingTitle';
import { Tag } from 'components/landing/ui/Tag';
import { Props } from 'pages/bestofeurope/types';

import card_calendarAvif from './assets/card_calendar.avif';
import card_calendar from './assets/card_calendar.jpg';
import card_participateAvif from './assets/card_participate.avif';
import card_participate from './assets/card_participate.jpg';
import card_teamAvif from './assets/card_team.avif';
import card_team from './assets/card_team.jpg';

const Root = styled(Vertical)`
  padding: calc(10 * var(--unit)) 0;
`;
const Pictures = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  align-items: center;
  padding: var(--double-unit);
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Image = styled(Img)`
  border-radius: 20px;
`;
const Block = styled.div`
  position: relative;
`;
const BlockContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: var(--double-unit);
`;
export const Howto = ({ signUp }: Props) => {
  return (
    <Root gap={8} center>
      <Vertical center>
        <Tag>
          <FormattedMessage
            id="BestOfEurope.Howto.chip"
            defaultMessage="Simple rules"
          />
        </Tag>
        <LandingTitle>
          <FormattedMessage
            id="BestOfEurope.Howto.title"
            defaultMessage="How to{br}participate?"
            values={{ br: <br /> }}
          />
        </LandingTitle>
      </Vertical>

      <Pictures>
        <Block>
          <picture>
            <source srcSet={card_participateAvif} type="image/avif" />
            <Image
              src={card_participate}
              alt=""
              width="368"
              height="532"
              fetchpriority="low"
            />
          </picture>
          <BlockContent className="text-center">
            <DisplayS>
              <FormattedMessage
                id="BestOfEurope.Howto.enter.title"
                defaultMessage="Enter a Best of Europe event"
              />
            </DisplayS>
            <BodyL>
              <FormattedMessage
                id="BestOfEurope.Howto.enter.description"
                defaultMessage="Each competition has exclusive prizes"
              />
            </BodyL>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={card_teamAvif} type="image/avif" />
            <Image
              src={card_team}
              alt=""
              width="368"
              height="532"
              fetchpriority="low"
            />
          </picture>
          <BlockContent className="text-center">
            <DisplayS>
              <FormattedMessage
                id="BestOfEurope.Howto.cards.title"
                defaultMessage="Submit your team"
              />
            </DisplayS>
            <BodyL>
              <FormattedMessage
                id="BestOfEurope.Howto.cards.description"
                defaultMessage="It's free to play"
              />
            </BodyL>
          </BlockContent>
        </Block>
        <Block>
          <picture>
            <source srcSet={card_calendarAvif} type="image/avif" />
            <Image
              src={card_calendar}
              alt=""
              width="368"
              height="532"
              fetchpriority="low"
            />
          </picture>
          <BlockContent className="text-center">
            <DisplayS>
              <FormattedMessage
                id="BestOfEurope.Howto.calendar.title"
                defaultMessage="Tuesdays & Fridays"
              />
            </DisplayS>
            <BodyL>
              <FormattedMessage
                id="BestOfEurope.Howto.calendar.description"
                defaultMessage="New competitions twice a week"
              />
            </BodyL>
          </BlockContent>
        </Block>
      </Pictures>
      <Button size="large" color="secondary" onClick={signUp}>
        <FormattedMessage
          id="BestOfEurope.Howto.cta"
          defaultMessage="Enter a competition"
        />
      </Button>
    </Root>
  );
};
